import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface NgLetContext<T> {
  ngLet: T;
  $implicit: T;
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[ngLet]',
  standalone: false,
})
export class NgLetDirective<T> {
  private context: NgLetContext<T | null> = { ngLet: null, $implicit: null };
  private hasView = false;

  // https://github.com/nigrosimone/ng-let/blob/main/projects/ng-let/src/lib/ng-let.directive.ts
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<NgLetContext<T>>,
  ) {}

  @Input()
  set ngLet(value: T) {
    this.context.$implicit = value;
    this.context.ngLet = value;

    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef, this.context);
      this.hasView = true;
    }
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  static ngTemplateGuard_ngLet: 'binding';
  static ngTemplateContextGuard<T>(dir: NgLetDirective<T>, ctx: any): ctx is NgLetContext<Exclude<T, false | 0 | '' | null | undefined>> {
    return true;
  }
}
